<script setup>
  import { storeToRefs } from "pinia";
  import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
  import { Input } from "@/components/ui/input";
  import { Label } from "@/components/ui/label";
  import { Select } from "@/components/episto-ui/select";
  import ThreePanePage from "@templates/ThreePanePage.vue";
  import { useTemplateStore } from "@stores/mailing/template";
  import { useAccountsStore } from "@stores/accounts";

  const accountsStore = useAccountsStore();
  const templateStore = useTemplateStore();
  const { availableAccountsOptions } = storeToRefs(accountsStore);
  const { template } = storeToRefs(templateStore);
</script>

<template>
  <ThreePanePage>
    <template #center>
      <Card class="w-full gap-6 p-6">
        <CardHeader>
          <CardTitle>Template settings</CardTitle>
        </CardHeader>
        <CardContent class="space-y-4">
          <div class="space-y-2">
            <Label for="template-name">Name</Label>
            <Input
              id="template-name"
              v-model="template.name"
              placeholder="Template name" />
          </div>

          <div class="space-y-2">
            <Label for="template-account">Account</Label>
            <Select
              id="template-account"
              v-model="template.account_id"
              :options="availableAccountsOptions"
              placeholder="Select an account"
              filterable />
          </div>
        </CardContent>
      </Card>
    </template>
  </ThreePanePage>
</template>
